import { AxiosTeenus } from './axios-teenus';

export class TeavitusteTeenus {    

    public async annaMinuTeavitused(): Promise<string[]> {
        const axios = new AxiosTeenus();
        const response = await axios.get(`/api/teavitused/minuteavitused`);
        return response?.data as string[];
    }    
}